import React, { Dispatch } from "react";
import {
  Header,
  HeaderCloseButton,
  ModalContentDiv,
  ModalTitle,
} from "./styles";
import { useTranslation } from "react-i18next";

interface ISuccessReorderModalContentProps {
  onClose: () => void;
}

const SuccessReorderModalContent = ({ onClose }: ISuccessReorderModalContentProps) => {
  const { t } = useTranslation();

  return (
    <ModalContentDiv>
      <Header>
        <HeaderCloseButton onClick={onClose}>
          [X] {t("closeModal")}
        </HeaderCloseButton>
      </Header>
      <ModalTitle>{t("successfullyReordered")}</ModalTitle>
    </ModalContentDiv>
  );
};

export default SuccessReorderModalContent;
